import { render, staticRenderFns } from "./DetailQuestion.vue?vue&type=template&id=6ba65c2e&scoped=true"
import script from "./DetailQuestion.vue?vue&type=script&lang=js"
export * from "./DetailQuestion.vue?vue&type=script&lang=js"
import style0 from "./DetailQuestion.vue?vue&type=style&index=0&id=6ba65c2e&prod&lang=scss&scoped=true"
import style1 from "./DetailQuestion.vue?vue&type=style&index=1&id=6ba65c2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba65c2e",
  null
  
)

export default component.exports